import React from "react";
import { StaticInfoMessageProps } from "models/propTypes/messagePropTypes";

export interface ContentTree {
  mainText: React.ReactNode;
  subTree: (React.ReactNode | ContentTreeNode)[];
  messageBubbles?: StaticInfoMessageProps[];
}

export class ContentTreeNode {
  mainText: React.ReactNode;
  subTree: (React.ReactNode | ContentTreeNode)[];

  constructor(mainText: React.ReactNode, subTree: (React.ReactNode | ContentTreeNode)[]) {
    this.mainText = mainText;
    this.subTree = subTree;
  }
}
